import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import EditNicknamesModal from './EditNicknamesModal';

export const useEditNicknamesModal = () => {
  const { openModal } = useDynamicModal();

  const openEditNicknamesModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      openModal({
        modal: ({ toggle }) => <EditNicknamesModal teamId={teamId} onClose={toggle} />,
      });
    },
    [openModal],
  );

  return { openEditNicknamesModal };
};

export default useEditNicknamesModal;
